import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tokens-gifted',
  templateUrl: './tokens-gifted.component.html',
  styleUrls: ['./tokens-gifted.component.scss']
})
export class TokensGiftedComponent implements OnInit {
  
  @Input() public amount;
  @Input() public redirectTo;
  @Input() public type;
  @Input() public message;
  
  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
  ) { }

  ngOnInit() {
  }
  closeDialog() {
    // if(this.redirectTo !== undefined){
    //   this.router.navigateByUrl('/dashboard', {skipLocationChange: true})
    //     .then(()=>this.router.navigate([this.redirectTo]));
    // }
    this.activeModal.dismiss();
  }
}
